import React, { useState, useEffect, useMemo } from "react";
import styles from "../Styles/Reporting.module.css";
import BarChart from "../Components/BarChart.js";
import TopReservers from "../Components/TopReservers.js";
import { useSelectedCompany } from "../Commoncontext/SelectedCompanyContext.js";
import ReservationsTable from "../Components/ReservationsTable.js";
import IconReporting from "../Images/IconReporting.js";
import { VarauskalenteritRaportointiProvider } from "../Commoncontext/VarauskalenteritRaportointiContext.js";
import { useUsers } from "../Commoncontext/UsersContext";

function Reporting() {
  const [selectedTilaId, setSelectedTilaId] = useState("NT4wTSfcKZt2Dq4ZDfHc");
  const [selectedTimeframe, setSelectedTimeframe] = useState("currentMonth");

  const { selectedCompanyId } = useSelectedCompany();
  const { fetchUsers } = useUsers();

  const [tilaList, setTilaList] = useState([]);

  // ✅ Lasketaan nämä memoilla jotta eivät muutu kesken renderin
  const { currentYear, currentMonth } = useMemo(() => {
    const now = new Date();
    return {
      currentYear: now.getFullYear(),
      currentMonth: now.getMonth() + 1, // 1-12
    };
  }, []);

  // ✅ Alku: kuluva kk valittuna
  const [selectedMonths, setSelectedMonths] = useState([
    `${new Date().getFullYear()}-${new Date().getMonth() + 1}`,
  ]);

  useEffect(() => {
    if (selectedCompanyId) {
      fetchUsers(selectedCompanyId);
    }
  }, [selectedCompanyId, fetchUsers]);

  // ✅ apu: muodosta "YYYY-M" Date-oliosta
  const ymKey = (d) => `${d.getFullYear()}-${d.getMonth() + 1}`;

  // ✅ apu: palauta lista täydellisistä kuukausista taaksepäin
  // includeCurrent = true  -> sisältää kuluvan kuukauden
  // includeCurrent = false -> alkaa edellisestä kuukaudesta
  const getLastFullMonths = (count, includeCurrent) => {
    const months = [];
    const start = new Date(currentYear, currentMonth - 1, 1);

    // jos ei haluta kuluvaa, siirrytään ensin 1kk taakse
    if (!includeCurrent) start.setMonth(start.getMonth() - 1);

    for (let i = 0; i < count; i++) {
      const d = new Date(start);
      d.setMonth(start.getMonth() - i);
      months.push(ymKey(d));
    }

    return months;
  };

  const handleTimeframeChange = (timeframe) => {
    setSelectedTimeframe(timeframe);

    let months = [];

    if (timeframe === "currentMonth") {
      // ✅ vain kuluva kk
      const d = new Date(currentYear, currentMonth - 1, 1);
      months = [ymKey(d)];
    }

    if (timeframe === "previousMonth") {
      // ✅ vain edellinen kk
      const d = new Date(currentYear, currentMonth - 1, 1);
      d.setMonth(d.getMonth() - 1);
      months = [ymKey(d)];
    }

    if (timeframe === "last3Months") {
      // ✅ edelliset täydet 3kk (ei sisällä kuluvaa)
      months = getLastFullMonths(3, false);
    }

    if (timeframe === "last12Months") {
      // ✅ edelliset täydet 12kk (ei sisällä kuluvaa)
      months = getLastFullMonths(12, false);
    }

    setSelectedMonths(months);
  };

  const handleBarChartSelection = (updatedSelectedMonths) => {
    setSelectedMonths(updatedSelectedMonths);
    setSelectedTimeframe(null); // POISTETAAN aikavalinta, kun käyttäjä klikkaa pylvästä
  };

  useEffect(() => {
    const fetchTilaList = async () => {
      const mockTilaList = [
        { id: "NT4wTSfcKZt2Dq4ZDfHc", nimi: "Saunatila" },
        { id: "AyaJrVOusUQRpBdRQRF4", nimi: "Etätyötila" },
      ];
      setTilaList(mockTilaList);
    };
    fetchTilaList();
  }, []);

  return (
    <VarauskalenteritRaportointiProvider
      talonyhtioId={selectedCompanyId}
      tilanTyyppi={selectedTilaId}
    >
      <div className={styles.container}>
        <div className={styles.pageTitle}>
          <div style={{ marginRight: "16px" }}>
            <IconReporting />
          </div>
          <h2>Raportointi</h2>
        </div>

        <div className={styles.selectionPart}>
          <div className={styles.timeframeSelector}>
            <select
              id="tilaSelect"
              className={styles.dropdown}
              value={selectedTilaId}
              onChange={(e) => setSelectedTilaId(e.target.value)}
            >
              {tilaList.map((tila) => (
                <option key={tila.id} value={tila.id}>
                  {tila.nimi}
                </option>
              ))}
            </select>
          </div>

          <div className={styles.timeframeSelector2}>
            <button
              className={`${styles.timeframeButton} ${
                selectedTimeframe === "last12Months" ? styles.selected : ""
              }`}
              onClick={() => handleTimeframeChange("last12Months")}
            >
              Edelliset 12kk
            </button>

            <button
              className={`${styles.timeframeButton} ${
                selectedTimeframe === "last3Months" ? styles.selected : ""
              }`}
              onClick={() => handleTimeframeChange("last3Months")}
            >
              Edelliset 3kk
            </button>

            <button
              className={`${styles.timeframeButton} ${
                selectedTimeframe === "previousMonth" ? styles.selected : ""
              }`}
              onClick={() => handleTimeframeChange("previousMonth")}
            >
              Edellinen kk
            </button>

            <button
              className={`${styles.timeframeButton} ${
                selectedTimeframe === "currentMonth" ? styles.selected : ""
              }`}
              onClick={() => handleTimeframeChange("currentMonth")}
            >
              Kuluva kk
            </button>
          </div>
        </div>

        <div className={styles.reportContainer}>
          <div className={styles.chartContainer}>
            <BarChart
              selectedMonths={selectedMonths}
              setSelectedMonths={handleBarChartSelection}
            />
          </div>

          <div className={styles.topReserversContainer}>
            <TopReservers selectedMonths={selectedMonths} />
          </div>
        </div>

        <div className={styles.tableContainer}>
          <ReservationsTable selectedMonths={selectedMonths} />
        </div>
      </div>
    </VarauskalenteritRaportointiProvider>
  );
}

export default Reporting;
